import $ from 'jquery';
// Django Ajax CSRF
function csrfSafeMethod(method) {
  return /^(GET|HEAD|OPTIONS|TRACE)$/.test(method);
}

function sameOrigin(url) {
  const host = document.location.host; // host + port
  const protocol = document.location.protocol;
  const srOrigin = '//' + host;
  const origin = protocol + srOrigin;
  return (
    url === origin ||
    url.slice(0, origin.length + 1) === origin + '/' ||
    (url === srOrigin ||
      url.slice(0, srOrigin.length + 1) === srOrigin + '/') ||
    !/^(\/\/|http:|https:).*/.test(url)
  );
}

$.ajaxSetup({
  beforeSend(xhr, settings) {
    if (!csrfSafeMethod(settings.type) && sameOrigin(settings.url)) {
      xhr.setRequestHeader(
        'X-CSRFToken',
        document.querySelector('meta[name="csrf"]').getAttribute('content'),
      );
    }
  },
});



// WEBPACK FOOTER //
// ./src/js/django-ajax-jquery.js